// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import cookie from 'js-cookie';

const fragments = {
  SLIDER: '[data-fragment="UspSlider.slider"]',
  CLOSE: '[data-fragment="UspSlider.closeButton"]',
};

export default class UspSlider extends WebComponent {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.initSwitch = this.initSwitch.bind(this);
  }

  didMount() {
    this.state = {
      itemHidden: false,
    };
    this.setState({
      itemHidden:  false,
    });
    this.switcherRunning = false;
    this.visibleItem = 0;
    this.slider = this.element.querySelector(fragments.SLIDER);
    this.sliderItems = this.slider.querySelectorAll('li');
    this.closeBtn = this.element.querySelector(fragments.CLOSE);
    this.setStateFromCookie();
    this.closeBtn.addEventListener('click', this.close);

    this.initSwitch();

    window.addEventListener('resize', this.initSwitch);
  }


  close() {
    this.setState({
      itemHidden:  true,
    });
    cookie.set('headerBarHidden', true);
  }
  setStateFromCookie() {
    const storeCookieValue = cookie.get('headerBarHidden');

    if (storeCookieValue === 'true') {
      this.close();
    }
  }
  initSwitch() {
    if ((window.innerWidth < 768) && (!this.switcherRunning)) {
      this.switchItem();
      this.switcherRunning = true;
    }
  }
  carousel() {
    this.sliderItems.forEach((sliderItem) => {
      sliderItem.classList.remove('active');
    });

    this.sliderItems[this.visibleItem].classList.add('active');
  }
  switchItem() {
    const { itemHidden } = this.state;

    if ((!itemHidden) && (window.innerWidth < 768)) {
      this.carousel();

      this.visibleItem = this.visibleItem + 1;

      if ((this.visibleItem + 1) > this.sliderItems.length) {
        this.visibleItem = 0;
      }
      this.timer = setTimeout(() => {
        this.switchItem();
      }, 5000);
    }
    else {
      this.switcherRunning = false;
    }
  }
  update() {
    const { itemHidden } = this.state;
    classNames(this.element, { 'hidden': itemHidden });
    classNames(this.element, { 'visible': !itemHidden });

    if (itemHidden) {
      document.documentElement.style.setProperty('--header-bar-height', '0px');
    }
    else {
      document.documentElement.style.setProperty('--header-bar-height', '40px');
    }
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/UspSlider.js